import { AccountswitchDatesController } from './accountswitchDates.controller';
import template from './accountswitchDates.html';

export const createRequestAccountswitchDatesComponent = {
  name: 'createRequestAccountswitchDates',
  restrict: 'E',
  template,
  controller: AccountswitchDatesController,
  controllerAs: 'vm',
  bindings: {
    descriptionTitle: '@',
    descriptionText: '@',
    model: '=',
    form: '=',
  },
};
